export default {
  data() {
    return {
      columns: [
        {
          prop: "id",
          label: "ID",
          default: "No ID"
        },
        {
          prop: "reference_id",
          label: "Reference ID",
          default: "No Reference ID"
        },
        {
          prop: "amount",
          label: "Amount"
        },
        {
          prop: "payment_type",
          label: "Payment"
        },
        {
          prop: "reservation",
          label: "reservation"
        },
        {
          prop: "note",
          label: "Note"
        },
        {
          prop: "status",
          label: "Status"
        },
        {
          prop: "type",
          label: "Type"
        },
        {
          prop: "created_at",
          label: "Created at"
        },
        {
          prop: "for_user",
          label: "For user"
        },
        {
          prop: "by_user",
          label: "By user"
        },
        {
          prop: "action",
          label: "Action",
          isAction: true
        }
      ],
      paginationMeta: {
        current_page: 1,
        last_page: 1,
        total: 0,
        per_page: 15
      },
      propsToSearch: ["name"],
      searchQuery: ""
    };
  }
};
